import { render, staticRenderFns } from "./deliveryDetail.vue?vue&type=template&id=a5467f44&scoped=true&"
import script from "./deliveryDetail.vue?vue&type=script&lang=js&"
export * from "./deliveryDetail.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDetail.vue?vue&type=style&index=0&id=a5467f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5467f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5467f44')) {
      api.createRecord('a5467f44', component.options)
    } else {
      api.reload('a5467f44', component.options)
    }
    module.hot.accept("./deliveryDetail.vue?vue&type=template&id=a5467f44&scoped=true&", function () {
      api.rerender('a5467f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/deliveryDetail.vue"
export default component.exports